/* ==========================================================================
   Beanwatch · Zustimmung (Cookie-Hinweis «Coffee & Cookies»)
   Seit 10.10.2026. Zeigt #cookie-hinweis, solange keine Wahl getroffen ist,
   und gibt die Wahl weiter (Entscheid Joscha: Die Wahl gilt auch für Google):

   - an Shopify: customerPrivacy.setTrackingConsent({ analytics, marketing,
     preferences }), wie der Hinweis im alten Theme;
   - an den Google Tag Manager im Consent Mode: gtag('consent', 'update', …).
     Die Grundeinstellung «denied» setzt das Theme im <head>
     (snippets/bw-tagmanager.liquid). Den Tag Manager selbst lädt das Theme
     seit 0.26.5 erst mit Zustimmung (Entscheid Joscha 12.10.2026): Bei
     «Alle Cookies akzeptieren» ruft dieses Skript bwTagManager() auf, bei
     «Nur notwendige Cookies» lädt er nie;
   - als Spiegel in localStorage 'bw-zustimmung' ('alle' oder 'notwendig'),
     damit der <head> sie beim nächsten Laden sofort kennt, noch bevor die
     Schnittstelle von Shopify geladen ist.

   Wer schon im alten Theme gewählt hat, bekommt keinen Hinweis: Shopify
   kennt die Wahl, sie wird still übernommen.

   Ändern lässt sich die Wahl über den Knopf «Cookie-Einstellungen» unten
   im Fuss (seit 20.10.2026, Entscheid Joscha). Eine Zustimmung muss sich so
   leicht zurücknehmen lassen, wie sie gegeben wurde (DSGVO, gilt für
   Besucher aus Liechtenstein). Der Knopf steht verborgen im Markup, dieses
   Skript zeigt ihn. Er öffnet den Hinweis wieder, nach der Wahl springt der
   Fokus zu ihm zurück. Wer von «Alle» auf «Nur notwendige» wechselt,
   bekommt sofort «denied» bei Google und ein Nein bei Shopify; der schon
   geladene Tag Manager bleibt bis zum nächsten Laden auf der Seite.

   Im Prototyp gibt es weder Shopify noch gtag, dort zeigt und speichert das
   Skript nur.

   Aufruf: BWZustimmung.start()
   ========================================================================== */

(function (global) {
  'use strict';

  const SPIEGEL = 'bw-zustimmung';

  function lesen() {
    try { return global.localStorage.getItem(SPIEGEL); } catch (e) { return null; }
  }
  function merken(wert) {
    try { global.localStorage.setItem(SPIEGEL, wert); } catch (e) { /* privates Fenster */ }
  }

  // Google im Consent Mode. Ohne gtag (Prototyp) passiert nichts. Mit
  // Zustimmung lädt danach der Tag Manager; bwTagManager() aus dem Theme
  // lädt ihn höchstens einmal.
  function google(alle) {
    if (typeof global.gtag !== 'function') return;
    const wert = alle ? 'granted' : 'denied';
    global.gtag('consent', 'update', {
      analytics_storage: wert,
      ad_storage: wert,
      ad_user_data: wert,
      ad_personalization: wert
    });
    if (alle && typeof global.bwTagManager === 'function') global.bwTagManager();
  }

  // Die Schnittstelle von Shopify laden; ohne Shopify (Prototyp) nie.
  // sonst() läuft, wenn sie fehlt oder nicht lädt.
  function shopify(fertig, sonst) {
    const s = global.Shopify;
    if (!s || typeof s.loadFeatures !== 'function') { if (sonst) sonst(); return; }
    s.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (fehler) => {
      if (!fehler && s.customerPrivacy) fertig(s.customerPrivacy);
      else if (sonst) sonst();
    });
  }

  function start() {
    const hinweis = document.getElementById('cookie-hinweis');
    if (!hinweis) return;

    // Kam der Hinweis über «Cookie-Einstellungen», geht der Fokus danach
    // dorthin zurück.
    let zurueck = null;
    const zu = () => {
      hinweis.hidden = true;
      if (zurueck) { zurueck.focus(); zurueck = null; }
    };

    function waehlen(alle) {
      merken(alle ? 'alle' : 'notwendig');
      google(alle);
      shopify((cp) => cp.setTrackingConsent({
        analytics: alle, marketing: alle, preferences: alle
      }, () => {}));
      zu();
    }

    hinweis.querySelectorAll('[data-zustimmung]').forEach((knopf) => {
      knopf.addEventListener('click', () => waehlen(knopf.dataset.zustimmung === 'alle'));
    });

    document.querySelectorAll('[data-zustimmung-aendern]').forEach((knopf) => {
      knopf.hidden = false;
      knopf.addEventListener('click', () => {
        zurueck = knopf;
        hinweis.hidden = false;
        const erster = hinweis.querySelector('[data-zustimmung]');
        if (erster) erster.focus();
      });
    });

    if (lesen()) return;               // schon gewählt, Hinweis bleibt zu

    // Hat der Besucher bei Shopify schon gewählt (altes Theme), übernehmen
    // wir das still. Sonst den Hinweis zeigen, ohne Shopify sofort. Der
    // Fokus springt nicht hin: Der Hinweis steht als Erstes im <body>, die
    // Tabulatortaste erreicht ihn also gleich.
    const zeigen = () => { hinweis.hidden = false; };
    shopify((cp) => {
      const stand = typeof cp.getTrackingConsent === 'function' ? cp.getTrackingConsent() : '';
      if (stand === 'yes' || stand === 'no') {
        merken(stand === 'yes' ? 'alle' : 'notwendig');
        google(stand === 'yes');
      } else {
        zeigen();
      }
    }, zeigen);
  }

  global.BWZustimmung = { start };
})(window);
